import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const MenuPaginator = styled.div`
  position: relative;

  .acoes-dropdown {
    display: ${props => (props.show ? 'block' : 'none')};
    position: absolute;
    right: 0px;
    left: 0px;
    top: 25px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
    z-index: 10;
    min-width: 180px;
    padding: 0.6rem 0;
  }

  .acoes-item {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.12rem 0;
  }

  .dropdown-label {
    display: block;
    width: calc(100% - 16px);
    margin: 0 8px;
    padding: 0.48rem 1.2rem;
    border-radius: 6px;
    background: transparent;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    font-weight: 500;
    font-size: 0.8rem;
    cursor: pointer;
    color: #2d3a4a;
    border: 1px solid transparent;
    box-shadow: none;
    white-space: nowrap;
    outline: none;
  }

  .dropdown-label:hover,
  .dropdown-label:focus {
    background-color: #58d0ff;
    color: #fff;
    border: 1px solid #58d0ff;
  }
`;

export default function PageOrderBy({ toggleMenuOrdenacao, onChange, onClose }) {
  var handleClick = function (value) {
    onChange(value);
    if (onClose) onClose();
  };

  return (
    <MenuPaginator show={toggleMenuOrdenacao}>
      <div className="acoes-dropdown">
        <div className="acoes-item">
          <span className="dropdown-label" onClick={() => handleClick('cadastro')}>
            Últimos Cadastros
          </span>
        </div>
        <div className="acoes-item">
          <span
            className="dropdown-label"
            onClick={() => handleClick('ocorrencia')}
          >
            Últimas Ocorrências
          </span>
        </div>
        <div className="acoes-item">
          <span className="dropdown-label" onClick={() => handleClick('nomeAZ')}>
            Nome A-Z
          </span>
        </div>
        <div className="acoes-item">
          <span className="dropdown-label" onClick={() => handleClick('nomeZA')}>
            Nome Z-A
          </span>
        </div>
      </div>
    </MenuPaginator>
  );
}
